import * as React from 'react';
import { mergeStyles } from '@cian/utils/lib/shared/style';

import * as styles from './underlineNavigation.css';

export interface IUnderlineNavigationLink {
  href: string;
  text: string;
}

export interface IUnderlineNavigation {
  links: IUnderlineNavigationLink[];
  activeHref: string;
  className?: string;

  navigate(event: React.MouseEvent<HTMLAnchorElement>, href: string): void;
}

export const UnderlineNavigation = ({ links, navigate, activeHref, className }: IUnderlineNavigation) => (
  <ul {...mergeStyles(styles['underline_navigation'], className)}>
    {links.map(link => (
      <li key={link.href} className={activeHref === link.href ? styles['active'] : ''}>
        <a href={link.href} onClick={event => navigate(event, link.href)}>
          {link.text}
        </a>
      </li>
    ))}
  </ul>
);
